import React from "react";

import Alert from "@busbud/design-system-components/dist/Alert";

import { Markdown } from "@app/components/text-formatting";
import { useAppContext } from "@app/helpers/hooks";

const TEXT_PARAMS = {
  support_url: "mailto:support@busbud.com"
};

export const CancelFailedAlert: React.FC = () => {
  const { translator } = useAppContext();
  return (
    <Alert size="sm" severity="negative" data-testid="cancel-failed-alert">
      <Markdown link_target_blank>
        {translator.t(
          "!account.trip-details.cancellation-alerts.failed",
          TEXT_PARAMS
        )}
      </Markdown>
    </Alert>
  );
};

export const RoundtripAlert: React.FC = () => {
  const { translator } = useAppContext();
  return (
    <Alert size="sm" severity="notice" data-testid="roundtrip-alert">
      {translator.t("!account.trip-details.cancel-tickets-message.roundtrip")}
    </Alert>
  );
};
